import {PaginationProps} from "../types/daily-feedback-reports-page-pagination.types";

export const defaultDailyFeedbackReportsPaginationData = {
  size: 10,
  number: 0,
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0
}

export const defaultPaginationProps: PaginationProps = {
  size: 10,
  page: 0
}
